
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    icon: {
      type: String,
      default: "bi-list",
    },
    position: {
      type: String,
      default: "top right",
    },
    open: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sidePanelClasses() {
      const a = this.position.split(" ").map((v) => "side-panel-" + v);
      if (this._open) a.push("side-panel-open");
      return a;
    },
  },
  data() {
    return { _open: this.open };
  },
  watch: {
    open() {
      this._open = this.open;
    },
  },
});
